
































































































































import { Component, Mixins } from "vue-property-decorator";
import { ContractsModule } from "@/store/contracts.module";
import { RatingModule } from "@/store/rating.module";
import { RatingSaveDTO } from "../../../lib/rating.type";
import FormValidator from "@/mixins/FormValidator";
import { AuthService } from "@/services/auth.service";

@Component({})
export default class RatingDialog extends Mixins(FormValidator) {
  isNew: boolean = true;
  ratingValue: number = 0;
  comments: string = "";
  BIN: string = "";
  selected: number = 0;
  badIntf: boolean = null as any;
  fewFunc: boolean = null as any;
  other: boolean = null as any;

  formRef = "rating-form";

  get badValues() {
    return [
      {
        id: 0,
        name: this.$t("rating.bad_interface"),
        value: 0,
      },
      {
        id: 1,
        name: this.$t("rating.few_func"),
        value: 1,
      },
      {
        id: 2,
        name: this.$t("rating.other"),
        value: 2,
      },
    ];
  }

  get getTextRating() {
    let result: string = "";
    switch (this.ratingValue) {
      case 1: {
        result = this.$t("rating.stars1").toString();
        break;
      }
      case 2: {
        result = this.$t("rating.stars2").toString();
        break;
      }
      case 3: {
        result = this.$t("rating.stars3").toString();
        break;
      }
      case 4: {
        result = this.$t("rating.stars4").toString();
        break;
      }
      case 5: {
        result = this.$t("rating.stars5").toString();
        break;
      }
      default: {
        result = "";
        break;
      }
    }
    if (result != "") {
      result = "(" + result + ")";
    }
    return result;
  }

  closeDialogRating() {
    ContractsModule.setShowRatingDialog(false);
  }

  get showRatingDialog() {
    const r = ContractsModule.showRatingDialog;
    if (r) {
      this.isNew = true;
      this.ratingValue = 0;
      this.comments = "";
      this.badIntf = null as any;
      this.fewFunc = null as any;
      this.other = null as any;
    }
    return r;
  }
  set showRatingDialog(val: boolean) {
    this.isNew = val;
    ContractsModule.setShowRatingDialog(val);
  }

  saveRating() {
    if (!this.validateForm()) return;
    this.isNew = false;
    localStorage.setItem(
      "lastRatingDate",
      (new Date().getTime() / 1000).toFixed(0),
    );
    AuthService.logout();

    const req: RatingSaveDTO = new RatingSaveDTO();
    req.BIN = ContractsModule.BINForRating;
    req.mark = this.ratingValue;
    req.email = ContractsModule.EmailForRating;
    req.comment =
      //this.comments +
      (this.ratingValue > 0 && this.ratingValue < 4 && this.badIntf
        ? this.badValues[0].name + "; "
        : "") +
      (this.ratingValue > 0 && this.ratingValue < 4 && this.fewFunc
        ? this.badValues[1].name + "; "
        : "") +
      (this.ratingValue > 0 && this.ratingValue < 4 && this.other
        ? this.badValues[2].name + "; "
        : "") +
      this.comments;
    RatingModule.saveRating(req);
    setTimeout(() => {
      this.closeDialogRating();
    }, 5000);
  }

  mounted() {
    this.isNew = true;
    this.ratingValue = 0;
    this.comments = "";
  }
}
